import { gql } from '@apollo/client'

import { useMutation } from 'hooks'
import { AUTH_QUERY } from 'modules/auth'

const USER_REGISTER_MUTATION = gql`
  mutation UserRegister($userRegister: UserRegister!) {
    userRegister(userRegister: $userRegister) {
      id
      errors {
        field
        message
      }
    }
  }
`

export const useUserRegisterMutation = opts =>
  useMutation(USER_REGISTER_MUTATION, {
    ...opts,
    refetchQueries: [{ query: AUTH_QUERY }],
    awaitRefetchQueries: true
  })
